import React from 'react'

import { connect } from "react-redux"

import { Form } from 'react-form'

import { Card } from 'primereact/card'

import EmployeeTable from '../components/employee/employee-table'
import EmployeeDetails from '../components/employee/employee-details'

import { EMPLOYEE_TYPE_UNDERTAKING, EMPLOYEE_TYPE_OTHER } from "../js/const"

import * as lookupCodeActionCreators from "../actionCreators/lookupCode"
import * as employeeActionCreators from "../actionCreators/employee"
import * as appActionCreators from "../actionCreators/app"

class AnnualReturnEmployee extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDisplayingUndertakingEmployeeDialog: false, // determines whether persons undertaking lobbyist employee details dialog is hidden or shown
            isDisplayingOtherEmployeeDialog: false, // determines whether other employee details dialog is hidden or shown
            selectedUndertakingEmployee: {}, // determines which persons undertaking lobbyist employee  employee is selcted in the table. It will be highlighted
            selectedOtherEmployee: {} // determines which other employee is selcted in the table. It will be highlighted
        }
    }

    selectEmployee = (e, type) => this.loadAndOpenEmployeeDetails(e.data, type)

    loadAndOpenEmployeeDetails = (employee, type) => {
        let employeeId = employee ? employee.EmployeeId : null
        this.props.setLoading(true)
            .then(() => {
                // load restriction lookup codes for drop down
                return this.props.getEmployeeRestrictions()
            })
            .then(() => {
                // load employee view model to get validation rules
                return this.props.getEmployee({ employeeId, type })
            })
            .then(() => {
                // show dialog and higlight selected client
                // open pop up. check type to see which pop up to open
                if (type === EMPLOYEE_TYPE_UNDERTAKING) {
                    this.setState({ isDisplayingUndertakingEmployeeDialog: true, selectedUndertakingEmployee: employee || {} })
                } else if (type === EMPLOYEE_TYPE_OTHER) {
                    this.setState({ isDisplayingOtherEmployeeDialog: true, selectedOtherEmployee: employee || {} })
                }
            })
            .then(() => this.props.setLoading(false))
            .catch((error) => this.props.handleError(error)
                .then(() => this.props.setLoading(false)))
    }

    closeEmployeeDetails = type => {
        // close pop up. check type to see which pop up to close
        if (type === EMPLOYEE_TYPE_UNDERTAKING) {
            this.setState({ isDisplayingUndertakingEmployeeDialog: false, selectedUndertakingEmployee: {} })
        } else if (type === EMPLOYEE_TYPE_OTHER) {
            this.setState({ isDisplayingOtherEmployeeDialog: false, selectedOtherEmployee: {} })
        }

        // clear loaded employee in store since we are done with it
        this.props.clearEmployee()
    }

    render() {
        // check if current employee that is being looked at exists. If not create an empty object to deal with issues that could be caused by employee being undefined
        // i.e. when binding to employee.Entity.EmployeeName there could be issues when employee is undefined since we are trying to access a property off of a propery
        let currentEmployee = this.props.employee.currentEmployee ? this.props.employee.currentEmployee : {}

        let employees = this.props.annualReturnEmployee.annualReturnEmployees ? this.props.annualReturnEmployee.annualReturnEmployees : []
        let lobbyistEmployees = employees.filter(employee => employee.EmployeeTypeCode === EMPLOYEE_TYPE_UNDERTAKING)
        let otherEmployees = employees.filter(employee => employee.EmployeeTypeCode === EMPLOYEE_TYPE_OTHER)

        let employeeDetailsProps = {
            canSave: this.props.canSave,
            canSeePrivateData: this.props.canSeePrivateData,
            currentEmployee: currentEmployee,
            closeEmployeeDetails: this.closeEmployeeDetails,
            employeeRestrictions: this.props.lookupCode.employeeRestrictions,
            downloadStatDec: this.downloadStatDec,
            deleteEmployee: this.deleteEmployee,
            statDecUpload: this.statDecUpload,
            isAnnualReturn: true
        }

        let employeeTableProps = {
            canSave: this.props.canSave,
            selectEmployee: this.selectEmployee,
            addEmployee: null,
            isAnnualReturn: true
        }
        return (
            <React.Fragment>
                <Card title="People Undertaking Lobbyist Activities">
                    <EmployeeTable employees={lobbyistEmployees} selectedEmployee={this.state.selectedUndertakingEmployee} type={EMPLOYEE_TYPE_UNDERTAKING}
                        {...employeeTableProps}></EmployeeTable>
                    {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                    this is useful when needed to clear the form or populating the form from another component
                    onSubmit is called when the form has been submitted and has passed validation
                    formApi properties can be found at https://react-form.js.org/#/*/}
                    <Form values={currentEmployee}>
                        {formApi => {
                            employeeDetailsProps.submitForm = formApi.submitForm
                            employeeDetailsProps.isDisplayingDialog = this.state.isDisplayingUndertakingEmployeeDialog
                            employeeDetailsProps.type = EMPLOYEE_TYPE_UNDERTAKING
                            employeeDetailsProps.statDecError = this.state.statDecError
                            return (
                                <EmployeeDetails {...employeeDetailsProps} />
                            )
                        }
                        }
                    </Form>
                </Card>
                <Card title="Other Employees">
                    <EmployeeTable employees={otherEmployees} selectedEmployee={this.state.selectedOtherEmployee} type={EMPLOYEE_TYPE_OTHER}
                        {...employeeTableProps}></EmployeeTable>
                    {/* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
                    this is useful when needed to clear the form or populating the form from another component
                    onSubmit is called when the form has been submitted and has passed validation
                    formApi properties can be found at https://react-form.js.org/#/*/}
                    <Form values={currentEmployee}>
                        {formApi => {
                            employeeDetailsProps.submitForm = formApi.submitForm
                            employeeDetailsProps.isDisplayingDialog = this.state.isDisplayingOtherEmployeeDialog
                            employeeDetailsProps.type = EMPLOYEE_TYPE_OTHER
                            return (
                                <EmployeeDetails {...employeeDetailsProps} />
                            )
                        }
                        }
                    </Form>
                </Card>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    let { annualReturnEmployee, employee, lookupCode } = state
    return { annualReturnEmployee, employee, lookupCode }
}

// this is how to combine actions available
const actionCreators = {
    ...appActionCreators,
    ...employeeActionCreators,
    ...lookupCodeActionCreators
}

export default connect(mapStateToProps, actionCreators)(AnnualReturnEmployee);


// WEBPACK FOOTER //
// ./src/container/AnnualReturnEmployee.js